module.exports = __webpack_public_path__ + "img/map_4.a7ddb138.jpg";